import React, { Component } from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import CardSimple from 'screens/components/basic/CardSimple';
import EmailInput from 'screens/components/basic/EmailInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import SelectInput from 'screens/components/basic/SelectInput';

class GeneralInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const countries = LOOKUP.common.country.options || null;
        if (!countries) return null;
        
        const currency = LOOKUP.common.currency || null;
        if (!currency) return null;

        return (
            <div>
                <CardSimple>
                        <div className="row">
                            <h4 className="ml-1">GENERAL OPTIONS</h4>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <SelectInput
                                        name={LOOKUP.menu.admin.generalInfo.labels.shippingLocation.label}
                                        fullWidth={true}
                                        label={LOOKUP.menu.admin.generalInfo.labels.shippingLocation.label}
                                        floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.shippingLocation.label}
                                        hintText={LOOKUP.menu.admin.generalInfo.labels.shippingLocation.hintText}
                                        options={countries} required />
                                </div> {/* .col */}
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <SelectInput
                                        name={LOOKUP.menu.admin.generalInfo.labels.currencyOption.label}
                                        fullWidth={true}
                                        label={LOOKUP.menu.admin.generalInfo.labels.currencyOption.label}
                                        floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.currencyOption.label}
                                        hintText={LOOKUP.menu.admin.generalInfo.labels.currencyOption.hintText}
                                        options={currency} required />
                                </div> {/* .col */}
                        </div> {/* .row */}
                        <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                    <TextInput 
                                        name={LOOKUP.menu.admin.generalInfo.labels.numberOfDecimal.label}
                                        type="number"
                                        fullWidth={true}
                                        label={LOOKUP.menu.admin.generalInfo.labels.numberOfDecimal.label}
                                        floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.numberOfDecimal.label}
                                        hintText={LOOKUP.menu.admin.generalInfo.labels.numberOfDecimal.hintText} />
                                </div> {/* .col */}
                        </div> {/* .row */}
                    <div className="row">
                        <h4 className="ml-1">BASIC SITE INFO</h4>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput 
                                name={LOOKUP.menu.admin.generalInfo.labels.siteTitle.label}
                                type="text"
                                fullWidth={true}
                                label={LOOKUP.menu.admin.generalInfo.labels.siteTitle.label}
                                floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.siteTitle.label}
                                hintText={LOOKUP.menu.admin.generalInfo.labels.siteTitle.hintText} />
                        </div> {/* .col */}
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <TextInput 
                                name={LOOKUP.menu.admin.generalInfo.labels.tagLine.label}
                                type="text"
                                fullWidth={true}
                                label={LOOKUP.menu.admin.generalInfo.labels.tagLine.label}
                                floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.tagLine.label}
                                hintText={LOOKUP.menu.admin.generalInfo.labels.tagLine.hintText} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <EmailInput 
                                name={LOOKUP.menu.admin.generalInfo.labels.adminEmail.label}
                                label={LOOKUP.menu.admin.generalInfo.labels.adminEmail.label}
                                floatingLabelText={LOOKUP.menu.admin.generalInfo.labels.adminEmail.label}
                                hintText={LOOKUP.menu.admin.generalInfo.labels.adminEmail.hintText}
                                maxLength={60}
                                fullWidth={true} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <div className="row">
                        <h4 className="ml-1 mb-2 mt-3">REVIEW</h4>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                            <ToggleInput 
                                className="enable_product_review" 
                                name="enableProductReview"
                                label={LOOKUP.menu.admin.generalInfo.productReviewStatus.label} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                            <ToggleInput 
                                className="approval_product_review" 
                                name="approvalProductReview"
                                label={LOOKUP.menu.admin.generalInfo.approvalByManager.label} />
                        </div> {/* .col */}
                    </div> {/* .row */}

                </CardSimple>
                <br />
                <div className="row">
                    <div className="col-lg-12">
                        <Button name="buttonSave"
                            className="pull-right"
                            label={LOOKUP.menu.admin.coupon.controls.saveButton}
                            primary={true} />
                        <Button name="buttonCancel"
                            className="pull-right btn-space"
                            label={LOOKUP.common.cancel.text} />
                    </div> {/* .col */}
                </div> {/* .row */}
            </div> 
        );
    }
}


export default GeneralInfo;